import Vue from "vue";
const store = Vue.$store;
import Router from "vue-router";
import auth from "./middlewares/auth";
import middlewarePipeline from "./middlewarePipeline";
Vue.use(Router);
//-----------Prevent SSR Duplicate Routing issue----------------
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

export function createRouter () {

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/:date(\\d{4}-\\d{2}-\\d{2})?/:icc(\odi|t20i|test-match|youth-odi|youth-t20|youth-test|list-a-odi|list-a-t20|list-a-test)?",
      name: "allMatches",
      component: () => import("@/components/matches/AllMatches"),
    },
    {
      path: "/my-matches",
      name: "myMatches",
      component: () => import("@/components/matches/AllMatches"),
    },
    {
      path: "/live-matches",
      name: "liveMatches",
      component: () => import("@/components/matches/AllMatches"),
      meta: {
        hideNavbar: true,
       }
    },
    {
      path: "/cricket-livecenter/match/:match/CricketWidget",
      name: "livecenter",
      component: () => import("@/components/livecenter/cricketwidget"),
    },
    {
      path: "/match/:match",
      name: "matchDetail",
      component: () => import("@/components/matches/MatchDetail"),
      children: [
        {
          path: "scorecard",
          name: "matchDetail.Scorecard",
          component: () => import("@/components/matches/Scorecard"),
        },
        {
          path: "commentary",
          name: "matchDetail.Commentary",
          component: () => import("@/components/matches/Commentary"),
        },
        {
          path: "teams",
          name: "matchDetail.Teams",
          component: () => import("@/components/matches/Teams"),
        },
        {
          path: "match-info",
          name: "matchDetail.MatchInfo",
          component: () => import("@/components/matches/MatchInfo"),
        },
        {
          path: "news",
          name: "matchDetail.News",
          component: () => import("@/components/matches/News"),
        },
        {
          path: "videos",
          name: "matchDetail.Videos",
          component: () => import("@/components/matches/Videos"),
        }
      ]
    },
    {
      path: "/tournament/:tournament",
      name: "tournamentDetail",
      component: () => import("@/components/tournaments/Detail"),
      children: [
        {
          path: "matches",
          name: "tournamentDetail.Matches",
          component: () => import("@/components/tournaments/matches"),
        },
        {
          path: "standings",
          name: "tournamentDetail.Standings",
          component: () => import("@/components/tournaments/Standings"),
        },
        {
          path: "teams",
          name: "tournamentDetail.Teams",
          component: () => import("@/components/tournaments/Teams"),
        },
        {
          path: "stats",
          name: "tournamentDetail.Stats",
          component: () => import("@/components/tournaments/Stats"),
        }
      ]
    },
    {
      path: "/tournament/:tournament/team/:team",
      name: "teamDetail",
      component: () => import("@/components/teams/Detail"),
      children: [
        {
          path: "matches",
          name: "teamDetail.Matches",
          component: () => import("@/components/teams/Matches"),
        },
        {
          path: "standings",
          name: "teamDetail.Standings",
          component: () => import("@/components/teams/Standings"),
        },
        {
          path: "results",
          name: "teamDetail.Results",
          component: () => import("@/components/teams/Results"),
        },
        {
          path: "players",
          name: "teamDetail.Players",
          component: () => import("@/components/teams/Players"),
        },
        {
          path: "social",
          name: "teamDetail.social",
          component: () => import("@/components/teams/Social"),
        }
      ]
    },
    {
      path: "/tournament-news/:tournament",
      name: "tournamentNews",
      component: () => import("@/components/news/List"),

    },
    {
      path: "/news",
      name: "newsList",
      component: () => import("@/components/news/List"),
    },
    {
      path: "/news/:news/:match?",
      name: "newsArticle",
      component: () => import("@/components/news/Article"),
    },
    {
      path: "/highlights",
      name: "highlights",
      component: () => import("@/components/highlights/List"),
    },
    {
      path: "/search",
      name: "search",
      component: () => import("@/components/search/search"),
    },
    {
      path: "/about-us",
      name: "aboutUs",
      component: () => import("@/components/static/AboutUs"),
    },
    {
      path: "/faq",
      name: "faq",
      component: () => import("@/components/static/FAQ"),
    },
    {
      path: "/privacy-policy",
      name: "privacyPolicy",
      component: () => import("@/components/static/PrivacyPolicy"),
    },
    //
    {
      path: "/dcma",
      name: "dcma",
      component: () => import("@/components/static/Dcma"),
    },
    {
      path: "/contact-us",
      name: "contactUs",
      component: () => import("@/components/static/ContactUs"),
    },
    {
      path: "/terms-conditions",
      name: "termsConditions",
      component: () => import("@/components/static/TermsConditions"),
    },
    {
      path: "/player/:player",
      name: "playerDetail",
      component: () => import("@/components/Players/playerDetail"),
      children:[
        {
          path: "info",
          alias:"/",
          name: "playerDetail.info",
          component: () => import("@/components/Players/info"),
        },
        {
          path: "social",
          name: "playerDetail.Social",
          component: () => import("@/components/Players/social"),
        },
        // {

        //     path: "match/:match/inning/:inning/type/:type",
        //     name: "playerDetail.matchscore",
        //     component: () => import("@/components/Players/playerStats"),
        // },
        // {
        //   path: "match/:match/inning/:inning/role/:role",
        //   name: "playerDetail.bowlermatchscore",
        //   component: () => import("@/components/Players/bowlerStats"),
        // },
        {
          path: "matches",
          name: "playerDetail.match",
          component: () => import("@/components/Players/playerMatches"),
        },
        {
          path: "Batting-Bowling-Stats",
          name: "playerDetail.Battingbowlingstats",
          component: () => import("@/components/Players/PlayerBattingStats"),
        },
      ]
    },
    {
      path: "/:team",
      name: "TeamDetails",
      component: () => import("@/components/AllTeams/TeamDetail"),
      children: [
        {
          path: "players",
          alias: "/",
          name: "TeamDetails.Players",
          component: () => import("@/components/AllTeams/team_players"),
        },
        {
          path: "matches",
          name: "TeamDetails.Matches",
          component: () => import("@/components/AllTeams/GetMatchesDetail"),
        },
        {
          path: "social",
          name: "TeamDetails.Social",
          component: () => import("@/components/AllTeams/Social"),
        },
        {
          path: "news",
          name: "TeamDetails.News",
          component: () => import("@/components/AllTeams/News"),
        },
      ]
    },
    {
      path: "*",
      redirect: { name: 'allMatches' },
    }
  ]
});

function setLayout(to, from, next) {
  var layout = to.meta.layout || "defaultLayout";
  store.commit("SET_LAYOUT", layout);
  return next();
}

    return router;
}
